const TOKEN_KEY = 't';

function parseToken(raw: string | null): string | null {
  const token = raw?.trim().slice(0, 512) ?? '';
  if (!token || !token.includes('.')) {
    return null;
  }
  return token;
}

export function readAndClearLinkToken(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  const hash = window.location.hash.slice(0, 600);
  if (hash.startsWith('#')) {
    const params = new URLSearchParams(hash.slice(1));
    const token = parseToken(params.get(TOKEN_KEY));
    if (token) {
      params.delete(TOKEN_KEY);
      const remainder = params.toString();
      const nextHash = remainder ? `#${remainder}` : '';
      window.history.replaceState(
        null,
        '',
        `${window.location.pathname}${window.location.search}${nextHash}`,
      );
      return token;
    }
  }
  const search = window.location.search.slice(0, 600);
  if (!search.startsWith('?')) {
    return null;
  }
  const query = new URLSearchParams(search.slice(1));
  const token = parseToken(query.get(TOKEN_KEY));
  if (!token) {
    return null;
  }
  query.delete(TOKEN_KEY);
  const remainder = query.toString();
  const nextSearch = remainder ? `?${remainder}` : '';
  window.history.replaceState(null, '', `${window.location.pathname}${nextSearch}${window.location.hash}`);
  return token;
}
